import axios from 'axios';
import { GetDateInCurrentTimeZone } from '../../../components/utilities/dateUtilities';
import React, { useState } from 'react';
import Iframe from '../../../components/utilities/Iframe';
import {
  DocumentDateStyle,
  DocumentsDivStyle,
  DocumentTitleStyles,
  DownloadButton,
  DownloadButtonSection,
  FileMetaData,
  FileNameSection,
  OrderedTextStyle,
  PaperClipSection,
} from './LegacyStyles';
import { LegacyOrder, LegacyOrderDocument } from '../../types';
import { convertToFileDownload } from '../../../components/utilities/fileUtilities';
import {
  PaperClip,
  PreviewIcon,
  DownloadIcon,
} from '../../../components/icons';

const DocumentsSlideout = ({ legacyOrder }: { legacyOrder: LegacyOrder }) => {
  const [preview, setPreview] = useState({ iframeOpen: false, iframeUrl: '' });

  const handleOnClickPreview = (url: string) => {
    setPreview({ iframeOpen: true, iframeUrl: url });
  };

  const handleOnDocumentDownload = async (id: number) => {
    const { data } = await axios.get(`/api/clientdownload/downloadLegacyFile/${id}`);
    await convertToFileDownload(data.base64, data.fileName);
  };

  return (
    <React.Fragment>
      {preview.iframeOpen && (
        <Iframe
          url={preview.iframeUrl}
          onClose={() => setPreview({ iframeOpen: false, iframeUrl: '' })}
          width={'545px'}
        ></Iframe>
      )}
      <DocumentsDivStyle>
        <div style={{ paddingTop: '30px', marginBottom: 17 }}>
          <OrderedTextStyle>Documents</OrderedTextStyle>
        </div>
        {legacyOrder.documents.map((d: LegacyOrderDocument, index: number) => {
          return (
            <DownloadButton key={index} style={{ marginBottom: 17 }}>
              <PaperClipSection>
                <PaperClip />
              </PaperClipSection>
              <FileNameSection
                onClick={() =>
                  handleOnClickPreview(
                    `/api/clientOrder/viewDocument?documentId=${d.id}`
                  )
                }
              >
                <DocumentTitleStyles>
                  {`${d.description}.pdf`}
                </DocumentTitleStyles>
                <FileMetaData>
                  <DocumentDateStyle>
                    Created{' '}
                    {GetDateInCurrentTimeZone(d.dateCreated).format(
                      'MM/DD/YYYY'
                    )}
                  </DocumentDateStyle>
                </FileMetaData>
              </FileNameSection>
              <DownloadButtonSection>
                <div
                  onClick={() =>
                    handleOnClickPreview(
                      `/api/clientOrder/viewDocument?documentId=${d.id}`
                    )
                  }
                >
                  <PreviewIcon />
                </div>

                <div onClick={() => handleOnDocumentDownload(d.id)}>
                  <DownloadIcon background="transparent" stroke="red" />
                </div>
                {/* {iframeOpen && <PreviewDoc onClose={() => setIframeOpen(false)} open={iframeOpen} url={iframeUrl} />} */}
              </DownloadButtonSection>
            </DownloadButton>
          );
        })}
      </DocumentsDivStyle>
    </React.Fragment>
  );
};
export default DocumentsSlideout;
